import React, { useEffect, useState } from 'react';
import { dispatchService } from '../../services/central-api/dispatch';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';

interface Props {
    value: number;
    setValue: (value: number, item: DisplaceReason | undefined) => void;
    zIndex: number;
    unitName?: string;
    allowEmpty?: boolean;
}

export default function DisplacedReasonDropdown({ value, setValue, zIndex, unitName, allowEmpty }: Props) {
    const [selectableDisplaces, setSelectableDisplaces] = useState<{
        label: string;
        value: number;
        category: 'arrested' | 'hospitalized' | null;
    }[]>([]);

    async function getDisplaceReasons() {
        try {
            const displacedReasons = await dispatchService.getDisplaceReasons();
            setSelectableDisplaces([
                ...(allowEmpty ? [{ value: 0, label: '', category: null }] : []),
                ...displacedReasons.map((item) => {
                    return {
                        label: item.name,
                        value: item.id,
                        category: item.category
                    };
                })
            ]);
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getDisplaceReasons();
    }, []);

    return (
        <FilterDropdown
            label={translate('displaced') + (unitName ? `: ${unitName}` : '')}
            items={selectableDisplaces}
            multiple={false}
            setValue={(v) => {
                const itemId = v(-1);

                const item = selectableDisplaces.find(d => d.value == itemId);

                setValue(itemId, item ? {
                    category: item.category,
                    id: item.value,
                    name: item.label,
                } : undefined);
            }}
            value={value}
            zIndex={zIndex}
        />
    );
}
